import { TraitsObserved } from './traits-observed';

export default TraitsObserved;
